import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  IconButton,
  Typography
} from '@mui/material';

import {
  AddOutlined,
  ApartmentOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  EmailOutlined,
  FaxOutlined,
  LocalPhoneOutlined,
  LocationOnOutlined
} from '@mui/icons-material';

import {
  actionButtonSx,
  editButtonSx,
  practiceActionsSx,
  practiceCardSx,
  practiceFieldSx,
  practiceHeaderSx,
  practiceIconSx,
  practiceLabelSx,
  practiceRowSx,
  practiceTitleSx,
  practiceValueSx
} from './styles';

const PracticeField = ({
  icon,
  label,
  value
}) => {
  return (
    <Box sx={practiceFieldSx}>
      {React.cloneElement(icon, {
        sx: practiceIconSx
      })}

      <Box sx={{ minWidth: 0 }}>
        <Typography sx={practiceLabelSx}>
          {label}
        </Typography>

        <Typography sx={practiceValueSx}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

PracticeField.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

const PracticeInformationCard = ({
  rows,
  onAdd,
  onEdit,
  onDelete
}) => {
  return (
    <Box sx={practiceCardSx}>
      <Box sx={practiceHeaderSx}>
        <Typography sx={practiceTitleSx}>
          Practice Information
        </Typography>

        <Button
          variant="outlined"
          startIcon={<AddOutlined sx={{ fontSize: 18 }}/>}
          onClick={onAdd}
          sx={editButtonSx}
          size='small'
        >
          Add Practice
        </Button>
      </Box>

      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ minWidth: 1350 }}>
          {rows.map(row => (
            <Box key={row.id} sx={practiceRowSx}>
              <PracticeField
                icon={<ApartmentOutlined />}
                label="Practice Name"
                value={row.practiceName}
              />

              <PracticeField
                icon={<CheckCircleOutlined />}
                label="Facility NPI"
                value={row.facilityNpi}
              />

              <PracticeField
                icon={<LocalPhoneOutlined />}
                label="Phone Number"
                value={row.phone}
              />

              <PracticeField
                icon={<FaxOutlined />}
                label="Fax"
                value={row.fax}
              />

              <PracticeField
                icon={<LocationOnOutlined />}
                label="Address"
                value={row.address}
              />

              <PracticeField
                icon={<EmailOutlined />}
                label="Email"
                value={row.email}
              />

              <Box sx={practiceActionsSx}>
                <IconButton
                  onClick={() => onEdit(row)}
                  aria-label={`Edit ${row.practiceName}`}
                  sx={actionButtonSx}
                >
                  <EditOutlined sx={{ fontSize: 18 }} />
                </IconButton>

                <IconButton
                  onClick={() => onDelete(row)}
                  aria-label={`Delete ${row.practiceName}`}
                  sx={actionButtonSx}
                >
                  <DeleteOutlined sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

PracticeInformationCard.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      practiceName: PropTypes.string.isRequired,
      facilityNpi: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      fax: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired
    })
  ).isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default PracticeInformationCard;